export class ComparisonInsurerDataFileReadException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ComparisonInsurerDataFileReadException';
  }
}
